import { api } from "../Configurations/axios";
import { InnovationActivityFinepModel } from "../Models/InnovationActivityFINEPModel";

const GetInnovationActivityByRegistrationDocumentsIdAPI = async (id: string) => {
    try {
        var result = await api.get(`/InnovationActivityFinep/GetByRegistrationDocumentsId/${id}`);
        var response = result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const PostInnovationActivityFinepAPI = async (data: InnovationActivityFinepModel) => {
    try {
        var result = await api.post('/InnovationActivityFinep/Post', data);
        var response = result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const PutInnovationActivityFinepAPI = async (data: InnovationActivityFinepModel) => {
    try {
        var result = await api.put('/InnovationActivityFinep/Put', data);
        var response = result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

export {
    GetInnovationActivityByRegistrationDocumentsIdAPI,
    PostInnovationActivityFinepAPI,
    PutInnovationActivityFinepAPI
}